import { render, staticRenderFns } from "./GuppyChatSendTextMessage.vue?vue&type=template&id=5f44f20b&scoped=true&"
import script from "./GuppyChatSendTextMessage.vue?vue&type=script&lang=js&"
export * from "./GuppyChatSendTextMessage.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatSendTextMessage.vue?vue&type=style&index=0&id=5f44f20b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f44f20b",
  null
  
)

export default component.exports